export default __webpack_public_path__ + "static/media/divider.b901366c.svg";